import ElakayImage from '../../components/images/ElakayImage';
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { elakay_API, resolveCategoryImageUrl } from "../../config";
import imgProductLakay from '../Layout/imgs/md3.jpg';
import Loader from "../Layout/loader.gif";
import CategoryMatrixPreview from "./CategoryMatrixPreview";
import "./CardCircle.css";

const CardCircle = ({
    infoSource,
    product = {},
    classCard0 = 'justify-content-center',
    classCard1 = '',
    // Matrix Mode (All Categories page only): when the PARENT of this
    // sub-category has Matrix Mode ON, the 4 best-selling products of this
    // sub-category ([] -> 4 neutral slots). undefined = default circle image,
    // which is what every other caller of this shared card gets.
    matrixProducts,
}) => {
    const [loaded, setLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    // DB URL first (image_c.photoUrl / urlImg on the category itself) --
    // the old `${elakay_API}/pubCi/${categoryId}` construction is only a
    // last-resort fallback for a category that has no stored image at all,
    // never the default. Used as-is: a stored/fallback URL here is already
    // a final, directly-loadable Elakay route (/image-assets/, /pubCi/, ...)
    // and must never be re-wrapped in getElakayImageLoadUrl()'s /img-load
    // proxy on top of that -- see isDirectElakayImageUrl() (config.js).
    const category = product?.supCategoryID;
    const categoryId = category?._id || category?.id || "";
    const storedUrl = resolveCategoryImageUrl(category, { variant: "circle" });
    const fallbackUrl = categoryId ? `${elakay_API}/pubCi/${categoryId}` : "";
    const directUrl = storedUrl || fallbackUrl;
    const url = directUrl;
    const categoryName = infoSource?.getCategoryNames?.(product)?.name?.[0] || category?.name?.[0] || "";
    return (
        <div className={`card-circle-container  ${classCard0}`}>
            <div className={`card-circle-wrapper${Array.isArray(matrixProducts) ? " card-circle-wrapper--matrix" : ""} ${classCard1}`}>
                {/* Image Card simple */}
                <Link 
                    to={`/product/${product?.supCategoryID?.publicId || product?.supCategoryID?._id}`}
                    className="card-circle-link"
                >
                    {Array.isArray(matrixProducts) ? (
                    <div className="card-circle-image-wrapper card-circle-image-wrapper--matrix">
                        {/* Matrix Mode: the name is part of the composition. */}
                        <CategoryMatrixPreview products={matrixProducts} title={categoryName} fallbackSrc={url} />
                    </div>
                    ) : (
                    <div className="card-circle-image-wrapper">
                        {/* Loader simple */}
                        {!loaded && !imageError && (
                            <div className="card-circle-loader">
                                <img src={Loader} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).cardCircle.t001} className="loader-img" />
                            </div>
                        )}
                        
                        {/* Image principale */}
                        <ElakayImage
                            preset="category"
                            fallback={imgProductLakay}
                            className="card-circle-image"
                            src={imageError ? imgProductLakay : url}
                            alt={categoryName}
                            loading="lazy"
                            decoding="async"
                            onLoad={() => setLoaded(true)}
                            onError={(event) => {
                                setImageError(true);
                                event.target.src = imgProductLakay;
                            }}
                            style={{ opacity: loaded || imageError ? 1 : 0 }}
                        />
                    </div>
                    )}
                </Link>
                
                {/* Nom de la catégorie (inside the card in Matrix Mode) */}
                {!Array.isArray(matrixProducts) && <div className="card-circle-name">
                    <Link 
                        to={`/product/${product?.supCategoryID?.publicId || product?.supCategoryID?._id}`}
                        className="card-circle-name-link"
                    >
                        {categoryName}
                    </Link>
                </div>}
            </div>
        </div>
    );
};

export default React.memo(CardCircle);